<template>
  <footer class="navbar-footer">
    <div class="container">
      <div class="row">
        <div class="col-footer">
          <div class="footer-logo"></div>
        </div>
        <ul class="col">
          <li>
            <router-link to="/#/help/faq">
              Perguntas Frequentes
            </router-link>
          </li>
          <li>
            <a href="/v2.html#/terms">
              Termos e condições
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
